import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateSchoolClassSchoolTagMutationVariables = Types.Exact<{
  schoolTagId: Types.Scalars['Int'];
  schoolClassId: Types.Scalars['Int'];
}>;


export type CreateSchoolClassSchoolTagMutation = { __typename?: 'Mutation', createSchoolClassSchoolTag?: { __typename?: 'schoolsSchoolClassSchoolTag', school_tag_id: number, school_class_id: number } | null | undefined };


export const CreateSchoolClassSchoolTagDocument = gql`
    mutation CreateSchoolClassSchoolTag($schoolTagId: Int!, $schoolClassId: Int!) {
  createSchoolClassSchoolTag: schoolsCreateSchoolClassSchoolTag(
    school_tag_id: $schoolTagId
    school_class_id: $schoolClassId
  ) {
    school_tag_id
    school_class_id
  }
}
    `;
export type CreateSchoolClassSchoolTagMutationFn = Apollo.MutationFunction<CreateSchoolClassSchoolTagMutation, CreateSchoolClassSchoolTagMutationVariables>;

/**
 * __useCreateSchoolClassSchoolTagMutation__
 *
 * To run a mutation, you first call `useCreateSchoolClassSchoolTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolClassSchoolTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchoolClassSchoolTagMutation, { data, loading, error }] = useCreateSchoolClassSchoolTagMutation({
 *   variables: {
 *      schoolTagId: // value for 'schoolTagId'
 *      schoolClassId: // value for 'schoolClassId'
 *   },
 * });
 */
export function useCreateSchoolClassSchoolTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchoolClassSchoolTagMutation, CreateSchoolClassSchoolTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchoolClassSchoolTagMutation, CreateSchoolClassSchoolTagMutationVariables>(CreateSchoolClassSchoolTagDocument, options);
      }
export type CreateSchoolClassSchoolTagMutationHookResult = ReturnType<typeof useCreateSchoolClassSchoolTagMutation>;
export type CreateSchoolClassSchoolTagMutationResult = Apollo.MutationResult<CreateSchoolClassSchoolTagMutation>;
export type CreateSchoolClassSchoolTagMutationOptions = Apollo.BaseMutationOptions<CreateSchoolClassSchoolTagMutation, CreateSchoolClassSchoolTagMutationVariables>;